import { render, staticRenderFns } from "./relatorios_entradas_esc.vue?vue&type=template&id=53077ff1&scoped=true&"
import script from "./relatorios_entradas_esc.vue?vue&type=script&lang=js&"
export * from "./relatorios_entradas_esc.vue?vue&type=script&lang=js&"
import style0 from "./relatorios_entradas_esc.vue?vue&type=style&index=0&id=53077ff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53077ff1",
  null
  
)

export default component.exports